import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../common/loader";
import { formateDate, formateDateWithMonth } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
// import $ from "jquery";
import { Details } from "../../services/appointmentrating.service";
import Breadcrums from "../../common/breadcrumbs";
import { Placeholder} from "rsuite";

const RatingDetails = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const params = useParams();
  // const [query] = useSearchParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    {
      title: "Rating Details",
      url: "/admin/ratings/list/1",
    },
    { title: t("btn_view"), url: "" },
  ];


  useEffect(() => {
    Details({_id :params._id})
      .then((response) => {
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params._id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
               <div>
                <h6 className="main-content-label mb-3">{t("btn_view") + " " + t("label_rating_detail")}</h6>
              </div>
              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>
                    
                        <tr>
                          <th>{t("label_user_name")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.userData && showdefault.userData.name
                              ? showdefault.userData.name
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_user_email")}</th>
                          <td>
                          {showdefault && showdefault.userData && showdefault.userData.email
                              ? showdefault.userData.email
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_associate_name")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.associateData && showdefault.associateData.name
                              ? showdefault.associateData.name
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_associate_email")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.associateData && showdefault.associateData.email
                              ? showdefault.associateData.email
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_type")}</th>
                          <td className="text-capitalize">
                          {showdefault?.type ? showdefault?.type==="associate_to_babe" ? "By Associate":"By Babe User" : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_rating")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.rating 
                              ? showdefault.rating
                              : "N/A"}
                          </td>
                        </tr>
                        
                        
                        <tr>
                          <th>{t("label_rating_detail")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.ratingDetails 
                              ? `${showdefault.ratingDetails}`
                              : "N/A"}
                          </td>
                        </tr>
                      




                       


              

                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7}/>
              )}
            </div>

            <div className="mt-2 back-button mx-4">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() =>
                  navigate("/admin/ratings/list/1")
                }
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RatingDetails;
